module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C141"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEC")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORBES OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWGLEN")])]), _vm._v(" "), _c('p', {
    staticClass: "C269"
  }, [_vm._v("1865")]), _vm._v(" "), _c('p', {
    staticClass: "C169"
  }, [_vm._v("The Cullen Collection")]), _vm._v(" "), _c('p', {
    staticClass: "C271"
  }, [_vm._v("Volume 5")]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00245.jpeg",
      "width": "45%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00246.jpeg",
      "width": "60%"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e24020a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0008.vue
// module id = 84
// module chunks = 0